import type { Member } from "@/types/Member";

/**
 * The set of member ids that count as an organisation's own "party" for buffer purposes — the org's
 * members plus its owner id — derived from a member whose `organisation` is populated. Returns
 * undefined when there's no organisation (or it carries no ids), so callers fall back to
 * same-member-only behaviour with no change.
 *
 * This mirrors the server's `resolveSameOrgMemberIds`: an organisation's own bookings may butt
 * back-to-back (buffer waived), exactly as a single member's own bookings may. Client conflict
 * checks (the click interceptor, the duration adjuster, the room selector) pass this set so their
 * pre-checks agree with the authoritative server gate.
 */
export function orgPartyMemberIds(member: Member | null | undefined): ReadonlySet<string> | undefined {
  const org = member?.organisation;
  if (!org) return undefined;
  const ids = [...(org.members ?? []), org.ownerId].filter(Boolean) as string[];
  return ids.length ? new Set<string>(ids) : undefined;
}
